import styled from 'styled-components';
export var FieldBlock = styled.div.withConfig({
  displayName: "partials__FieldBlock",
  componentId: "sc-1id75i9-0"
})(["font-weight:400;h4{font-weight:700;}"]);